// IMPORT LIBS
import jQuery from 'jquery';
import Swiper from 'swiper';
import noUiSlider from 'nouislider';
import bootstrapBundle from '../../../node_modules/bootstrap/dist/js/bootstrap.bundle.js';
import "regenerator-runtime/runtime";

window.$ = jQuery;
window.jQuery = jQuery;
window.Swiper = Swiper;
window.noUiSlider = noUiSlider;
window.bootstrapBundle = bootstrapBundle;

// NEED TO USE "REQUIRE" IN THIS LIBRARY
const fancybox = require('../../../node_modules/@fancyapps/fancybox/dist/jquery.fancybox');
window.fancybox = fancybox;

// IMPORT CLASSES
import Used from './classes/Used';

// IMPORT FUNCTIONS
import { tabsCreate, tabsInit } from './functions/tabs';
import { swipersInit } from './functions/sliders';
import { accordionsCreate, controlAccordionsFilter } from './functions/accordions';
import { showPartialsFixed } from './functions/partialsFixed';
import { buttonCotationBehavior, buttonFilterBehavior } from './functions/actionsForm';
import { sidebarFixedBehavior } from './functions/sidebarFixed';
import { controlDate } from './functions/controlDate';
import { redirectPage } from './functions/redirectPage';
import { handleSetMoreHeight } from './functions/setHeights';
import { chooseUnits } from './functions/chooseLocation';

document.addEventListener('DOMContentLoaded', function () {
 
    // FUNCTION TO INIT CHOOSE LOCATION
    chooseUnits();

    // FUNCTION TO CREATE AND INIT SWIPERS
    swipersInit();

    // FUNCTION TO CONTROL HEADER/FOOTER FIXED
    window.addEventListener('scroll', () => {
        showPartialsFixed('.header-fixed', 'show-header-scrolled', 'hide-header-scrolled');
        showPartialsFixed('.footer-fixed', 'show-footer-scrolled', 'hide-footer-scrolled');
        showPartialsFixed('.header-mobile.fixed', 'show-header-scrolled', 'hide-header-scrolled');
    });


    // FUNCTION TO CONTROL BEHAVIOR OF COTATION BUTTONS
    buttonCotationBehavior('.button-call-form');
    buttonCotationBehavior('.button-product-cotation');

    const unitsSelect = document.querySelector('.units-select');
    if (unitsSelect) {
        showNavbarDropdown('.navbar-link.units-select-dropdown', '.navbar-dropdown-list.units-select-dropdown', 0);
    }

    // FUNCTION TO CONTROL BEHAVIOR OF SIDEBAR FIXED
    sidebarFixedBehavior('.sidebar');

    // FUNCTION TO INSERT CURRENT DATE IN INPUTS [TYPE=DATE]
    controlDate();

    // FUNCTION TO REDIRECT TO HOME PAGE
    redirectPage();

    // FUNCTION TO SET MORE HEIGHT AMONG THE ELEMENTS OF SAME TYPE
    handleSetMoreHeight('.js-sales-title', 992);
    handleSetMoreHeight('.js-promotion-name', 992);
    handleSetMoreHeight('.js-promotion-desc', 992);
    handleSetMoreHeight('.js-sales-req-title', 992);
    handleSetMoreHeight('.js-sales-req-desc', 992);
    handleSetMoreHeight('.js-sales-available-name', 0);
    handleSetMoreHeight('.js-sales-available-desc', 0);
    handleSetMoreHeight('.js-high-title', 992);
    handleSetMoreHeight('.js-high-desc', 992);


    setFamily();
    getModelFromParams();
    changeTestDriveImage();
});

function setFamily() {
    let searchParams = new URLSearchParams(window.location.search);
    const modelname = searchParams.get('modelname');
    const selector = ".my-tabs[data-content='" + modelname + "']";
    const selector2 = ".my-tabs-2[data-content='" + modelname + "']";
}

function getModelFromParams() {
    let searchParams = new URLSearchParams(window.location.search);
    const modelname = searchParams.get('modelname');

    if (modelname) {
        $('select#model').val(modelname);
        const imgWrapper = $('form .test-drive-form-img img');

        const img = $('select#model').find('option:selected').attr('data-image');
        imgWrapper.attr('src', img);
    }
}

function changeTestDriveImage() {
    const myInput = $('select#model');
    const imgWrapper = $('form .test-drive-form-img img');
    myInput.on('change', function (e) {
        const img = $(e.target).find('option:selected').attr('data-image');
        imgWrapper.attr('src', img);
    });
}

// FUNCTION TO UP TOP PAGE
$('.btn-scroll-top').on('click', function () {
    $('html,body').animate({ scrollTop: 0 }, '300')
});

// FUNCTION TO ADD OVERLAY ON MODALS
function popUp(selector) {
    $('body,html').addClass('scroll-lock');
    selector.fadeIn('fast');
}

function popClose(form) {
    form ? $('.modal-form').fadeOut() : $('.modal-overlay').fadeOut();
    $('body,html').removeClass('scroll-lock');
}

// FUNCTION TO PASS INFORMATION TO POP-UP PROMOTIONS
function modalInject(data, target) {
    const { title, img, text } = data;
    $(target).find('.promotion-title').html(title);
    $(target).find('.promotion-img').attr('src', img);
    $(target).find('.promotion-text').html(text);
    popUp($(target));
}

$('.btn-open-modal').on('click', function () {
    const el = $(this).data('target');
    const data = $(this).data('json');
    data ? modalInject(data, el) : popUp($(el));
})

// FUNCTION TO OPEN MODALS
$('.modal-overlay, .btn-close-modal').on('click', function (e) {
    $(e.target).hasClass('form-close') ? popClose(true) : popClose()
}).on('click', '.pop-up-content', function (event) {
    event.stopPropagation()
})

// FUNCTION TO CONTROL PAGINATIONS
let currentPage = 1;
let currentOrd = 'asc';

$('.order-control').on('click', function () {
    search(currentPage);
});

$('.page-link').on('click', function () {

    currentPage = $(this).data('page');
    $('.page-link').removeClass("active");
    $(this).addClass("active");
    search(currentPage);
});

$('.page-link').on('click', function () {
    currentPage = $(this).data('page');
    $('.page-item').removeClass("active");
    $(this.parentElement).addClass("active");

    if (currentPage != "1") {
        $('.left-arrow').removeClass("disabled");
    } else {
        $('.left-arrow').addClass("disabled");
    }

    search(currentPage);
});

//function to change values on radio buttons form honda evolution
document.addEventListener('DOMContentLoaded', function () {
    let cor = document.querySelector(".cor")
    let versao = document.querySelector(".versao")

    if (cor || versao) {
        cor.value = document.querySelector('input[name=cor]:checked').value;
        versao.value = document.querySelector('input[name=versao]:checked').value;
    }
});

$(document).ready(function () {
    $(".versao-radio").find("input[type='radio']").click(function () {
        let entradaId = $(this).attr("id");
        if (document.getElementById(entradaId).checked) {
            $(".versao").val(document.getElementById(entradaId).value);
        }
    });
    $(".cor-radio").find("input[type='radio']").click(function () {
        let entradaId = $(this).attr("id");
        if (document.getElementById(entradaId).checked) {
            $(".cor").val(document.getElementById(entradaId).value);

        }
    });
    $(".entrada-radio").find("input[type='radio']").click(function () {
        let entradaId = $(this).attr("id");
        if (document.getElementById(entradaId).checked) {
            $(".entrada").val(document.getElementById(entradaId).value);

        }
    });
    $(".parcelas-radio").find("input[type='radio']").click(function () {
        let entradaId = $(this).attr("id");
        if (document.getElementById(entradaId).checked) {
            $(".parcelas").val(document.getElementById(entradaId).value);

        }

    });
    $(".parcela-final-radio").find("input[type='radio']").click(function () {
        let entradaId = $(this).attr("id");

        if (document.getElementById(entradaId).checked) {
            $(".parcela-final").val(document.getElementById(entradaId).value);

        }
    });
});

$(".btn-close-filter").click(function () {
    $('#used-filter-data-modal').modal('hide');
});




function showSidebarDropdown(dropSidebar, contentSidebar, indexSidebar) {
    const dropdownSelected = document.querySelector(dropSidebar);
    const contentSelected = document.querySelectorAll(contentSidebar);
    const dropdownIcon = dropdownSelected.querySelector('i');

    dropdownSelected.addEventListener('click', () => {
        dropdownIcon.classList.toggle('rotate-element');
        contentSelected[indexSidebar].classList.toggle('d-flex');

        if (contentSelected[indexSidebar].classList.contains('d-flex')) {
            const dropdownHeight = contentSelected[indexSidebar].offsetHeight;

            dropdownSelected.style.cssText = `margin-bottom: calc(${dropdownHeight}px + 10px);`;
        } else {
            dropdownSelected.style.removeProperty('margin-bottom');
        }
    });
}


function lockScreenScroll() {
    const elementsDOM = document.querySelector('body, html');
    const lockScreen = document.querySelector('.lock-screen');

    elementsDOM.classList.toggle('scroll-lock');
    lockScreen.classList.toggle('d-flex');
}

const sidebarFixed = document.querySelector('.sidebar-fixed');
const formMain = document.querySelector('.form-main');
const filterHeader = document.querySelector('.header-filter');
const unitsSelect = document.querySelector('.units-select');

const closeMenu = `
    <div class="sidebar-wrapper close-sidebar">
      <i class="icon-fechar"></i>
      <span>Fechar</span>
    </div>`;

const openMenu = `
    <div class="sidebar-wrapper">
      <i class="icon-menu"></i>
      <span>Menu</span>
    </div>`;


let menuSelected = document.querySelectorAll('.sidebar');

menuSelected.forEach((target) => {

    target.addEventListener('click', () => {

        if (formMain && formMain.classList.contains('form-content-fixed')) {
            hideFixedForm();
            lockScreenScroll();
        }

        target.innerHTML === closeMenu
            ? target.innerHTML = openMenu
            : target.innerHTML = closeMenu;

        if (unitsSelect && target.classList.contains('fixed')) {
            sidebarFixed.classList.toggle('fixed');
        }

        sidebarFixed.classList.toggle('d-flex');
        lockScreenScroll();
    });
});